import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/projects/e-commerce-platform/client-page.tsx");
